export default {"src":"/_next/static/media/order.4d4d9bdc.svg","height":17,"width":20,"blurWidth":0,"blurHeight":0};